import React from "react";

const WeekdaysItem = ({ day, date, selectedDate, ...props }) => {
    const isCurrentDate = selectedDate.getDate() === date;
    return (
        <div
            {...props}
            className={`text-[#737373] px-3 py-[20px] text-center border-[1px] border-[#F3F3F3] rounded-xl min-w-[52px] cursor-pointer transition-all ${
                isCurrentDate && "bg-[#0073C7] !text-white cursor-not-allowed"
            }`}
        >
            <div className="font-medium text-xs leading-[18px] whitespace-nowrap">
                {day === 1 ? "CN" : `Thứ ${day}`}
            </div>
            <div className="text-base leading-[22px] font-semibold mt-3">
                {date}
            </div>
        </div>
    );
};

export default WeekdaysItem;
